// removed by extract-text-webpack-plugin
module.exports = {"ManageButton":"I3jIiaUjvLW2EnfzYpCNh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/EditButton/index.css
// module id = 853
// module chunks = 0